import { HeroLayout } from '@hg/stylizator/components'
import * as React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { IAttributes } from 'app/components/CustomBlocks/layout/HeroLayoutBlock/Attributes'

interface IProps extends IAttributes {
  innerBlocks: React.ReactElement
  os: string
  className?: string
}

const HeroLayoutComponent: React.FC<IProps> = (props) => {
  if (props.os.includes('windows') && props.titleWindows) {
    return (
      <HeroLayout
        className={props.className}
        body={props.bodyWindows!}
        button={props.innerBlocks}
        illustration={<LazyLoadImage src="/assets/illustrations/windows-device-download.svg" alt="windows device" />}
        title={props.titleWindows}
      />
    )
  }

  if (props.os.includes('mac') && props.titleMac) {
    return (
      <HeroLayout
        className={props.className}
        body={props.bodyMac!}
        button={props.innerBlocks}
        illustration={<LazyLoadImage src="/assets/illustrations/macos-device-download.svg" alt="macos device" />}
        title={props.titleMac}
      />
    )
  }

  if (props.os.includes('android') && props.titleAndroid) {
    return (
      <HeroLayout
        className={props.className}
        body={props.bodyAndroid!}
        button={props.innerBlocks}
        illustration={<LazyLoadImage src="/assets/illustrations/android-device-download.svg" alt="android device" />}
        title={props.titleAndroid}
      />
    )
  }

  return (
    <HeroLayout
      className={props.className}
      body={props.bodyLinux!}
      button={props.innerBlocks}
      illustration={<LazyLoadImage src="/assets/illustrations/linux-device-download.svg" alt="linux device" />}
      title={props.titleLinux!}
    />
  )
}

export default HeroLayoutComponent
